import styled from 'styled-components';

// Material-UI
import IconButton from '@material-ui/core/IconButton';

// *************************************
// STYLED COMPONENTS                               
// *************************************

// IconButton
export const StyledButtonIcon = styled(IconButton)`
  &.MuiIconButton-root {
    padding: 8px;
    color: ${(props) => props.theme.colors.greyDark}; 
    &:hover {
      background-color: ${(props) => props.theme.colors.greyHover};
    }
  }
`;